import React from 'react'
import { Switch, Route } from "react-router-dom"
import { Homepage, Playground, Services } from '../pages'
import { PageNotFound } from "./PageNotFound";
import { PLAYGROUND, SERVICES, ROOT } from "./CONSTANTS";
  
export const RouterConfig = () =>  {
    return (
        <>
            <Switch>
                <Route path={PLAYGROUND} exact component={Playground} />
                <Route path={SERVICES} exact component={Services} />
                <Route path={ROOT} exact component={Homepage} />

                {/* List a generic 404-Not Found route here */}
                <Route path="*">
                    <PageNotFound />
                </Route>


            </Switch>
        </>
    )
} 

